import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../../common/DeleteModal";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import imageIcon from "../../../../../images/image.svg";
import pinIcon from "../../../../../images/icons/pin.svg";
import unpinIcon from "../../../../../images/icons/unpin.svg";
import { Badge } from "react-bootstrap";
import ProductsService from "../../../../../services/ProductsService";
import ConfirmModal from "../../../../common/ConfirmModal";
import { toast } from "react-toastify";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const [changeModal, setChangeModal] = useState(false);
	const navigate = useNavigate();
	const productsService = new ProductsService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);

	const changeStatusToggle = () => {
		let type = !item?.pined ? "pin" : "removePin";
		productsService?.changePin(type, item?.id).then((res) => {
			if (res?.status) {
				toast.success("Pin Changed Successfully");
				setShouldUpdate((prev) => !prev);
			}
		});
	};

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item?.name_en}</td>
			<td className="text-wrap-mode">{item?.name_ar}</td>
			<td className="text-wrap-mode">
				{lang === "en" ? item?.category?.name_en : item?.category?.name_ar}
			</td>
			<td className="text-wrap-mode">{Number(item?.price).toFixed(3)}</td>
			<td className="text-wrap-mode">{Translate[lang][item?.type]}</td>
			<td className="text-wrap-mode">{item?.added_by}</td>
			<td className="text-wrap-mode">
				<a href={item?.image} target="_blank" rel="noreferrer">
					<img src={imageIcon} alt="imageIcon" width={32} />
				</a>
			</td>
			<td className="text-wrap-mode">
				<Badge variant="primary light">
					{Translate[lang][item?.status ? "active" : "deactive"]}
				</Badge>
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{(isExist("update_pin_market_place") ||
						isExist("add_pin_market_place") ||
						isExist("delete_pin_market_place")) && (
						<img
							src={item?.pined ? unpinIcon : pinIcon}
							onClick={() => {
								setChangeModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{isExist("update_products") && (
						<img
							src={editIcon}
							onClick={() => {
								navigate("/add-product", { state: item });
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{isExist("delete_products") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={lang === "en" ? item?.name_en : item?.name_ar}
					deletedItem={item}
					modelService={productsService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
			{changeModal && (
				<ConfirmModal
					open={changeModal}
					title={lang === "en" ? item?.name_en : item?.name_ar}
					body={
						lang === "en"
							? `are you sure about changing Pin for this Product?`
							: "هل أنت متأكد من تغيير التثبيت لهذا المنتج؟"
					}
					button={Translate[lang].submit}
					submitButton={changeStatusToggle}
					onCloseModal={() => setChangeModal(false)}
				/>
			)}
		</tr>
	);
};
export default CardItem;
